/**
 * @generated SignedSource<<b873620cd2eb3942e15db50e7938bdf2>>
 * @relayHash 79addbe137ec8d584deb2d903dc7de66
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b06e8643492c6f11ff7102ddfe2aed5d1097c08486edfbe4693735d05cf00986

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateCascadingSelectFieldInput = {
  id: string;
  operation: JiraCascadingSelectFieldOperationInput;
};
export type JiraCascadingSelectFieldOperationInput = {
  childOption?: string | null | undefined;
  operation: JiraSingleValueFieldOperations;
  parentOption?: string | null | undefined;
};
export type cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation$variables = {
  input: JiraUpdateCascadingSelectFieldInput;
};
export type cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation$data = {
  readonly jira: {
    readonly updateCascadingSelectField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly " $fragmentSpreads": FragmentRefs<"cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewOld_fragmentRef">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateCascadingSelectField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly cascadingOption: {
          readonly childOptionValue: {
            readonly id: string;
            readonly isDisabled: boolean | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined;
          readonly parentOptionValue: {
            readonly id: string;
            readonly isDisabled: boolean | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly fieldConfig: {
          readonly isEditable: boolean | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation = {
  rawResponse: cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation$rawResponse;
  response: cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation$data;
  variables: cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": isSingleLineEventDelegatorEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isSingleLineEventDelegatorEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-event-delegator-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "kind": "ScalarField",
    "name": "value"
  },
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraCascadingSelectFieldPayload",
            "kind": "LinkedField",
            "name": "updateCascadingSelectField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraCascadingSelectField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewOld_fragmentRef"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraCascadingSelectFieldPayload",
            "kind": "LinkedField",
            "name": "updateCascadingSelectField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraCascadingSelectField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "concreteType": "JiraCascadingOption",
                    "kind": "LinkedField",
                    "name": "cascadingOption",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": (v5/*: any*/)
                      },
                      {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": (v5/*: any*/)
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraFieldConfig",
                    "kind": "LinkedField",
                    "name": "fieldConfig",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isEditable"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b06e8643492c6f11ff7102ddfe2aed5d1097c08486edfbe4693735d05cf00986",
    "metadata": {},
    "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectField_Mutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": isSingleLineEventDelegatorEnabled_provider
    }
  }
};
})();

(node as any).hash = "d2aa8009e389257d3576f281dee876bf";

export default node;
